import { render, staticRenderFns } from "./RawMaterialsDetailOutput.vue?vue&type=template&id=f2709018&"
import script from "./RawMaterialsDetailOutput.vue?vue&type=script&lang=js&"
export * from "./RawMaterialsDetailOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports